import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const Microphone = ({
  width = 58,
  height = 58,
  className,
  color,
  decorative = false,
  ariaLabel = "Microphone",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 58 58"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path d="M44 28a1 1 0 0 0-1 1v6c0 7.72-6.28 14-14 14s-14-6.28-14-14v-6a1 1 0 1 0-2 0v6c0 8.485 6.644 15.429 15 15.949V56h-5a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2h-5v-5.051c8.356-.52 15-7.465 15-15.949v-6a1 1 0 0 0-1-1" />
      <path d="M29 46c6.065 0 11-4.935 11-11V11c0-6.065-4.935-11-11-11S18 4.935 18 11v24c0 6.065 4.935 11 11 11m-9-35c0-4.963 4.038-9 9-9s9 4.037 9 9v24c0 4.963-4.038 9-9 9s-9-4.037-9-9z" />
    </svg>
  );
};
